<template>
  <div class="uren-product_area">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="section-title_area">
            <span>Les Nouveautés de ce mois</span>
            <h3>Les <span class="text-primary-custom">Nouveautés</span></h3>
          </div>
          <div
            v-if="rows && rows.total > 0"
            class="product-slider uren-slick-slider slider-navigation_style-1 img-hover-effect_area"
          >
            <VueSlickCarousel v-bind="settingsCarousel">
              <div
                v-for="article in rows.data.slice(0, 10)"
                :key="article.id"
                class="product-slide_item"
              >
                <div class="inner-slide">
                  <div class="single-product">
                    <div
                      class="cart-icon-box"
                      @click="addPanier(article.uuid)"
                      v-show="inPanier(article.uuid)"
                    >
                      <i class="fa fa-shopping-cart cart-icon"></i>
                    </div>
                    <div class="product-img">
                      <router-link to="/">
                        <img
                          class="primary-img"
                          :src="URL + '/files/no_image_article.png'"
                          alt="Product Image"
                          v-if="article.image === null"
                        />
                        <span v-else>
                          <img
                            class="primary-img"
                            :src="URL + '/files/' + article.image"
                            alt="Product Image"
                          />
                        </span>
                      </router-link>
                      <div class="sticker">
                        <span class="sticker">New</span>
                      </div>
                    </div>
                    <div class="product-content">
                      <div class="product-desc_info">
                        <h6>
                          <router-link class="product-name" to="/product">{{
                            JSON.parse(article.designation)[locale]
                              ? JSON.parse(article.designation)[locale]
                              : "###"
                          }}</router-link>
                        </h6>
                        <div class="price-box">
                          <span class="new-price" v-if="Number(user.prix) === 1"
                            >{{ article.prix_vente_mru | currency }}
                          </span>
                        </div>
                      </div>
                      <div class="">
                        <a
                          v-show="!inPanier(article.uuid)"
                          class="uren-add_cart mr-4"
                          @click="addPanier(article.uuid)"
                          data-toggle="tooltip"
                          data-placement="top"
                          :title="addToCartText"
                          ><i
                            class="fas fa-cart-arrow-down text-success fa-2x"
                          ></i
                        ></a>
                        <a
                          v-show="inPanier(article.uuid)"
                          class="uren-add_cart mr-4"
                          @click="addPanier(article.uuid)"
                          data-toggle="tooltip"
                          data-placement="top"
                          :title="removeFromCartText"
                          ><i class="fas fa-shopping-cart text-danger fa-2x"></i
                        ></a>
                        <a
                          href="javascript:void(0)"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Quick View"
                          ><i class="ion-android-open fa-2x"></i
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <template #prevArrow>
                <button class="slick-prev">
                  <i class="ion-ios-arrow-back"></i>
                </button>
              </template>
              <template #nextArrow>
                <button class="slick-next">
                  <i class="ion-ios-arrow-forward"></i>
                </button>
              </template>
            </VueSlickCarousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constant from "@/constant";
import * as services from "@/modules/article/service/services";

export default {
  name: "NewArrivals",
  data() {
    return {
      URL: constant.URL_FILE,
      recherche: "",
      rows: {},

      serverParams: {
        searchTerm: null,
        sort: {
          field: "reference",
          type: "asc",
        },
        page: 1,
        sfamille: "0",
        perPage: 108,
      },
      settingsCarousel: {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 4,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1501,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
  methods: {
    getLang(fr, en) {
      if (this.locale === "fr") return fr;
      if (this.locale === "en") return en;
      return "";
    },
    getResults(page = 1) {
      this.updateParams({ page: page });
      this.updateParams({ sfamille: this.sf });
      axios
        .get(services.GET_DATA_TABLE, { params: this.serverParams })
        .then((response) => {
          this.rows = response.data;
        });
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    inPanier(articleUUID) {
      var objExiste = _.find(this.items, (o) => o.article === articleUUID);

      return !!objExiste;
    },
    addPanier(articleUUID) {
      let self = this;
      let message;

      var objExiste = _.find(self.rows.data, (o) => o.uuid === articleUUID);
      var objCheck = _.find(self.items, (o) => o.article === articleUUID);
      if (objExiste) {
        if (!objCheck) {
          self.items.push({
            article: objExiste.uuid,
            article_libelle: objExiste.designation,
            unite: objExiste.unite_uuid,
            unite_libelle: objExiste.unite,
            prix: objExiste.prix_vente_mru,
            image: objExiste.image,
            tva: self.assujjeti === 1 ? self.tva : 0,
            quantite: 1,
          });
          message = this.getLang(
            "Article ajouté à votre panier",
            "Article added to your cart"
          );
        } else {
          var notificationIndex = _.findIndex(
            self.items,
            (o) => o.article === articleUUID
          );
          self.items.splice(notificationIndex, 1);
          message = this.getLang(
            "Article retiré de votre panier",
            "Article removed from your cart"
          );
        }
        self.$swal({
          position: "top-end",
          icon: "success",
          text: message,
          showConfirmButton: false,
          timer: window.Timer,
        });
      }
    },
  },
  mounted() {
    this.getResults();
  },

  computed: {
    addToCartText() {
      return this.getLang("Ajouter au panier", "Add to cart");
    },
    removeFromCartText() {
      return this.getLang("Retirer du panier", "Remove from cart");
    },
    locale() {
      return this.$store.getters["configapp/locale"];
    },
    items: {
      get() {
        return this.$store.getters["cotation/currentCotation"].items;
      },
      set(value) {
        this.$store.dispatch("cotation/setCotation", { items: items });
      },
    },
    sf() {
      return this.$store.getters["cotation/filters"].sf;
    },
    assujjeti: function () {
      return this.$store.getters["auth/userp"].assujetti_tva;
    },
    user() {
      return this.$store.getters["auth/userp"];
    },
  },
};
</script>

<style lang="scss" scoped>
.primary-img,
.secondary-img {
  height: 300px;
}

.cart-icon-box {
  position: absolute !important;
  font-size: 20px;
  z-index: 23;
  right: 0;
  top: 0;
  padding: 1.2rem 2rem;
  cursor: pointer;

  .cart-icon {
    color: green;
  }

  &:hover .cart-icon {
    color: red;
  }
}

.product-img,
.primary-img,
.secondary-img {
  cursor: default;
}

.uren-add_cart {
  cursor: pointer;
}
</style>
